const reducer = (state = {}, action) =>{
    switch(action.type){
        case "setAttributes": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;  